<template>
    <path :style="{ fill: color }" d="M31.7,28.1C31.7,28,31.7,28,31.7,28.1c-0.2-2.5,0-4.9,1.2-7.9c1.2-3,3.8-5,9.6-8.8s5.5-0.9,17.5-0.8
	c12,0,17.7,12.9,17.7,12.9c1.8,3-0.2,11.4-0.6,13.7c-0.1,0.5-0.4,2-0.5,3.5c-0.1,1.2,0,2.5,0,3.4c-0.1,2-0.4,3-0.4,3
	c-1.4,0.7-1.8,5.9-2.2,5.8c-0.4-0.1,0-3.5-0.4-6.4c-0.3-2.3-1-3.8-1.3-6.2c-0.3-2.4,0.3-8.2-2.6-9.3c-2.9-1.1-6.5,2.1-15.1,2.1
	s-13.8-3.7-15.9-0.6c-2.1,3.1-1.4,5.2-1.5,8.3c-0.1,3.1-1.3,4.6-1.4,6.3c-0.1,1.9-0.2,5.2-0.5,5.2c-0.3,0.1-1-4.5-1.8-5.1
	c-0.1-0.2-0.4-1.4-0.5-3.5c0-1,0.2-2.5,0.1-3.6C33,37.6,31.8,32.3,31.7,28.1z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair3',
        mixins: [Hair],
    }
</script>

